var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatStrikethroughi = function SvgChatStrikethroughi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12.097 16h-.121a2.7 2.7 0 0 1-1.927-.734 2.09 2.09 0 0 1-.566-1.5.417.417 0 0 1 .466-.367.41.41 0 0 1 .4.422 1.4 1.4 0 0 0 .351.938 1.9 1.9 0 0 0 1.315.457 1.62 1.62 0 0 0 1.164-.355 1.62 1.62 0 0 0 .467-1.133 1 1 0 0 0-.075-.418.4.4 0 0 1 .247-.52.44.44 0 0 1 .551.219 1.9 1.9 0 0 1 .136.719 2.4 2.4 0 0 1-.737 1.715 2.32 2.32 0 0 1-1.616.563zm-3.679-3.777a.41.41 0 0 1-.416-.395.4.4 0 0 1 .416-.391h2.077a1.68 1.68 0 0 1-.777-1.461 2.05 2.05 0 0 1 .6-1.387 2.32 2.32 0 0 1 1.687-.59 2.4 2.4 0 0 1 1.706.578 1.95 1.95 0 0 1 .572 1.316.41.41 0 0 1-.416.4.41.41 0 0 1-.422-.4c0-.18-.081-1.1-1.44-1.1a1.54 1.54 0 0 0-1.1.355 1.23 1.23 0 0 0-.347.813c0 .742.548.969 1.6 1.336l.347.125h3.081a.414.414 0 0 1 .416.4.41.41 0 0 1-.416.395z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatStrikethroughi);
export default ForwardRef;